#import "./CanvasBlockBaseFields.graphql"

fragment ScheduleMeetingBlockFields on ScheduleMeetingBlock {
  ...CanvasBlockBaseFields
  url
  subtitle
}
